import { useState, useEffect } from "react";

// Utility debounce function
const debounce = (fn, delay) => {
  let timer;
  return (...args) => {
    clearTimeout(timer);
    timer = setTimeout(() => fn(...args), delay);
  };
};

export default function useScreenDimensions(delay = 200) {
  const getWindowDimensions = () => {
    if (typeof window !== "undefined") {
      return {
        width: window.innerWidth,
        height: window.innerHeight,
      };
    }
    return { width: 0, height: 0 };
  };

  const [dimensions, setDimensions] = useState(getWindowDimensions);

  useEffect(() => {
    if (typeof window === "undefined") return;

    const handleResize = debounce(() => {
      setDimensions(getWindowDimensions());
    }, delay);

    window.addEventListener("resize", handleResize);

    // Set initial size after mount
    handleResize();

    return () => window.removeEventListener("resize", handleResize);
  }, [delay]);

  return dimensions;
}
